import React from "react";
// import { AllNewspaperVendor } from "../../../FetchAPI";
import Sidebar from "../../Sidebar";
import DeshbordBreadcrumb from "../../Breadcrumb/DeshbordBreadcrumb";
import DeshBoardFooter from "../../DeshBoardFooter";
import { Link, useParams } from "react-router-dom";
import { NewsPaperVendorData } from "../../../FetchAPI";
import { useAuth } from "../../../../Store/AuthContext";
import { Helmet } from "react-helmet";
import { formatPrice } from "../../../Others/ImportantFunction";

export default function NewsPaperScheduleView() {
  let { newsid } = useParams();

  const { RendomTokenfetch } = useAuth();
  const [NewsVendorData] = NewsPaperVendorData(RendomTokenfetch, newsid);
  // console.log(NewsVendorData);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb
          page1={[
            { name: "News Paper Schedule", pagelink: "news-paper-schedule" },
            { name: "View" },
          ]}
        />
        <section className="user-dashboard">
          <div className="dashboard-outer">
            {/* Frist Row */}
            <div className="row">
              <div className="col-lg-12">
                <div className="ls-widget">
                  <div className="tabs-box">
                    <div className="widget-title pb-1 p-3 newsvendorfliderheading">
                      <p className="mb-1">
                        <Link
                          to={`/news-paper-schedule-edit/${newsid}`}
                          className="lead-link newspaperEditbtn"
                        >
                          Edit
                          <i
                            className=" mx-2 fa fa-pencil-square-o"
                            aria-hidden="true"
                          ></i>
                        </Link>
                      </p>
                    </div>
                    <div className="widget-content p-3">
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <th>Ticket ID. </th>
                            <td>{NewsVendorData?.ticket_id || ""}</td>
                          </tr>
                          <tr>
                            <th>News Paper Name</th>
                            <td>{NewsVendorData?.news_paper_name || ""}</td>
                          </tr>
                          <tr>
                            <th>State</th>
                            <td>{NewsVendorData?.state || ""}</td>
                          </tr>
                          <tr>
                            <th>City</th>
                            <td>{NewsVendorData?.city || ""}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Second Row */}
            <div className="row">
              <div className="col-lg-12">
                <div className="ls-widget">
                  <div className="tabs-box">
                    <div className="widget-content p-3">
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <th>Adds Formate</th>
                            <td>{NewsVendorData?.adds_formate || ""}</td>
                          </tr>
                          <tr>
                            <th>Lines</th>
                            <td>{NewsVendorData?.lines || ""}</td>
                          </tr>
                          <tr>
                            <th>Words</th>
                            <td>{NewsVendorData?.words || ""}</td>
                          </tr>
                          <tr>
                            <th>Recieved Date</th>
                            <td>{NewsVendorData?.recieved_date || ""}</td>
                          </tr>
                          <tr>
                            <th>Mode of Given</th>
                            <td>{NewsVendorData?.mode_of_give || ""}</td>
                          </tr>
                          <tr>
                            <th>Description</th>
                            <td
                              dangerouslySetInnerHTML={{
                                __html: NewsVendorData?.description || "",
                              }}
                            ></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Third Row */}
            <div className="row">
              <div className="col-lg-12">
                <div className="ls-widget">
                  <div className="tabs-box">
                    <div className="widget-content p-3">
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <th>Sent Publish Date</th>
                            <td>{NewsVendorData?.sent_publish_date || ""}</td>
                          </tr>
                          <tr>
                            <th>Publication Date</th>
                            <td>{NewsVendorData?.publication_date || ""}</td>
                          </tr>
                          <tr>
                            <th>Given by Employee Name</th>
                            <td>{NewsVendorData?.give_by_staffname || ""}</td>
                          </tr>
                          <tr>
                            <th>Share With Client</th>
                            <td>{NewsVendorData?.share_with_client || ""}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Five Row */}
            <div className="row">
              <div className="col-lg-12">
                <div className="ls-widget">
                  <div className="tabs-box">
                    <div className="widget-content p-3">
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <th>Attachment</th>
                            <td>
                              {NewsVendorData.attachment && (
                                <Link
                                  to={`${NewsVendorData.attachment}`}
                                  data-fancybox
                                  data-caption="attachment"
                                  className="pdfDownloadedBTN"
                                >
                                  <i
                                    className="fa fa-download"
                                    aria-hidden="true"
                                  ></i>
                                </Link>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th>Attachment URL</th>
                            <td>{NewsVendorData?.attachment_url || ""}</td>
                          </tr>
                          <tr>
                            <th>Our Quotation</th>
                            <td className="text-primary">
                              {formatPrice(NewsVendorData.our_cost)}
                            </td>
                          </tr>
                          <tr>
                            <th>Status</th>
                            <td>
                              <span
                                className="badge"
                                style={{
                                  color: `${NewsVendorData.status_color}`,
                                  backgroundColor: `${NewsVendorData.status_bgcolor}`,
                                }}
                              >
                                {NewsVendorData?.status || ""}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="ls-widget">
                  <div className="tabs-box">
                    <div className="widget-content p-3">
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <th>Vendor Quotation</th>
                            <td className="text-primary">
                              {formatPrice(NewsVendorData.vendor_amount)}
                            </td>
                          </tr>
                          <tr>
                            <th>Vendor Status</th>
                            <td>
                              {NewsVendorData.vender_statusid === "1" && (
                                <span className="badge bg-success">
                                  {NewsVendorData.vender_status}
                                </span>
                              )}
                              {NewsVendorData.vender_statusid === "0" && (
                                <span className="badge bg-danger">
                                  {NewsVendorData.vender_status}
                                </span>
                              )}
                              {NewsVendorData.vender_statusid === "2" && (
                                <span className="badge bg-danger">
                                  {NewsVendorData.vender_status}
                                </span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th>Vendor Description</th>
                            <td
                              dangerouslySetInnerHTML={{
                                __html:
                                  NewsVendorData?.vender_description || "",
                              }}
                            ></td>
                          </tr>

                          <tr>
                            <th>Date</th>
                            <td>{NewsVendorData?.date_new || ""}</td>
                          </tr>
                          <tr>
                            <th>Publish Status</th>
                            <td>
                              {NewsVendorData.status_new === "1" ? (
                                <span className="badge bg-success">
                                  Publish
                                </span>
                              ) : (
                                <span className="badge bg-danger">
                                  UnPublish
                                </span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th>PDF Update</th>
                            <td>
                              {NewsVendorData.pdf_update && (
                                <Link
                                  to={`${NewsVendorData.pdf_update}`}
                                  data-fancybox
                                  data-caption="pdf"
                                  className="pdfDownloadedBTN"
                                >
                                  <i
                                    className="fa fa-download"
                                    aria-hidden="true"
                                  ></i>
                                </Link>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="deshboard_footer">
          <DeshBoardFooter />
        </div>
      </div>
    </>
  );
}
